import { render, staticRenderFns } from "./NotificacionesHistoricas.vue?vue&type=template&id=0b098840"
import script from "./NotificacionesHistoricas.vue?vue&type=script&lang=ts"
export * from "./NotificacionesHistoricas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports